/**
 * Datos de un adjunto en una línea: «12 KB · Stephen Lucic · 28 oct». El nombre va corto (el completo
 * en `title`) y la fecha y hora exactas en el `title` de la fecha.
 */
import type { Adjunto } from '@cdtec-backlog/contrato';
import { nombreCorto } from '../../componentes/Avatar';
import { fechaCorta, fechaHora, formatearTamano } from '../../lib/formato';

export function MetaAdjunto({ adjunto, className }: { adjunto: Adjunto; className?: string }) {
  const quien = adjunto.subidoPor?.nombre;
  return (
    <span className={className}>
      {formatearTamano(adjunto.tamano)} ·{' '}
      <span title={quien}>{quien ? nombreCorto(quien) : 'Persona eliminada'}</span> ·{' '}
      <time dateTime={adjunto.creadoEn} title={fechaHora(adjunto.creadoEn)}>
        {fechaCorta(adjunto.creadoEn)}
      </time>
    </span>
  );
}
